import { Controller } from '@hotwired/stimulus'

const IDENTIFIER = 'sw-waiting-for-result'

export default class extends Controller {
  static targets = ['form']

  static values = {
    delay: { type: Number, default: 5000 }
  }

  declare readonly formTarget: HTMLFormElement
  declare readonly hasFormTarget: boolean
  declare delayValue: number

  private timeoutId: number | null = null

  identify(): string {
    return IDENTIFIER
  }

  connect(): void {
    if (!this.hasFormTarget) return

    this.timeoutId = window.setTimeout(() => {
      this.submitForm()
    }, this.delayValue)
  }

  disconnect(): void {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId)
    }
  }

  submitForm(): void {
    if (!this.hasFormTarget) return

    this.formTarget.requestSubmit()
  }
}
